module.exports = __webpack_public_path__ + "img/clients.bda475ef.svg";